import { render, staticRenderFns } from "./DelayNotice.vue?vue&type=template&id=0b453bff&scoped=true&"
import script from "./DelayNotice.vue?vue&type=script&lang=js&"
export * from "./DelayNotice.vue?vue&type=script&lang=js&"
import style0 from "./DelayNotice.vue?vue&type=style&index=0&id=0b453bff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b453bff",
  null
  
)

export default component.exports